<!--
- Bu ekranı yaptım ama turnuva bazında eşleştirmelerin SS-MK için 
anlamı olmadığını takım eşleştirmelerine geçince fark ettim.
- Örneğin Türkiye 3. Lig için SS servisinde 4 tane unique-tournament var,
(her grup için ayrı ayrı) Fakat MK servisinde 3. Lig sadece bir
competition'dan oluşuyor (kendi içinde gruplara ayrılmış)
- Ayrıca SS servisinde Süper Lig'de olan takım, MK servisinde 1. ligde olabiliyor
Karşılaştığım bu durumlardan dolayı bu ekranı pasif bırakıyorum.
-->

<template>
    <div class="p-grid p-mx-auto p-mt-4">
        <div class="p-col-12 p-md-4 p-mx-auto">
            <h3>SS Category</h3> 
            <Dropdown class="p-col-12 p-md-12 p-text-left" placeholder="Select Category"
                v-model="categoryLinks.selected"
                @change="ssCategoryChanged()"
                :options="categoryLinks.items" :loading="categoryLinks.isLoading"
                optionLabel="ssCategoryContainer.name"
                :filter="true" filterPlaceholder="Find Category" />
        </div>
        <div class="p-col-12 p-md-2"></div>
        <div class="p-col-12 p-md-4 p-mx-auto">
            <h3>MK Category</h3> 
            <Dropdown class="p-col-12 p-md-12 p-text-left" placeholder="Select Category"
                :disabled="true"
                v-model="categoryLinks.selected"
                @change="mkCategoryChanged()"
                :options="categoryLinks.items" :loading="categoryLinks.isLoading"
                optionLabel="mkAreaContainer.name" />
        </div>
    </div>

    <div v-if="categoryLinks.selected.ssCategoryContainer !== undefined
            && categoryLinks.selected.ssCategoryContainer !== null
            && categoryLinks.selected.ssCategoryContainer.uniqueTournaments !== undefined
            && categoryLinks.selected.ssCategoryContainer.uniqueTournaments !== null
            && categoryLinks.selected.ssCategoryContainer.uniqueTournaments.length > 0">
        <div class="p-grid p-mx-auto p-mt-4">
            <div class="p-col-12 p-md-4 p-mx-auto">
                <h3>Select Unique Tournament</h3>
                <Listbox v-model="tournamentLink.ssUniqueTournamentId"
                    :options="categoryLinks.selected.ssCategoryContainer.uniqueTournaments"
                    optionLabel="name" optionValue="id"
                    @change="ssUniqueTournamentSelected()"
                    class="p-col-12 p-md-12 p-text-left"
                    :filter="true" listStyle="max-height:500px" />
            </div>
            <div class="p-col-12 p-md-1 p-mx-auto p-text-center">
                <div class="p-col-12 p-md-12">
                    <Button label="<" 
                        @click="previousCategory()"
                        class="p-button-md p-button-outlined p-button-secondary" />

                    <Button label=">" 
                        @click="nextCategory()"
                        class="p-button-md p-ml-2 p-button-outlined p-button-secondary" />
                </div>

                <Button label="Match Tournaments" 
                    :disabled="tournamentLink.isLoading"
                    @click="createTournamentLink()"
                    style="margin-top:100px;"
                    class="p-button-lg p-button-raised p-button-primary" />

                <Button label="Remove Link" 
                    :disabled="(tournamentLink.isLoading 
                        || tournamentLink.ssUniqueTournamentId === undefined || tournamentLink.ssUniqueTournamentId === null
                        || tournamentLink.mkCompetitionId === undefined || tournamentLink.mkCompetitionId === null)"
                    @click="removeTournamentLink()"
                    class="p-button-lg p-button-outlined p-button-danger"
                    style="margin-top: 150px" />
            </div>
            <div class="p-col-12 p-md-4 p-mx-auto">
                <h3>Select Competition</h3>
                <Listbox v-model="tournamentLink.mkCompetitionId"
                    :options="categoryLinks.selected.mkAreaContainer.competitions"
                    optionLabel="name" optionValue="id"
                    class="p-col-12 p-md-12 p-text-left"
                    :filter="true" listStyle="max-height:500px" />
            </div>
        </div>
    </div>
</template>


<script>
import axios from "axios";
import Dropdown from 'primevue/dropdown'
import Listbox from 'primevue/listbox'
import Button from 'primevue/button'

let SpringApi;

export default {
    name: 'SS-MK Tournament Links',
    components: {
        Dropdown, Listbox, Button
    },
    data() {
        return {
            categoryLinks: {
                isLoading: false,
                selected: {},
                items: []
            },
            tournamentLink: {
                isLoading: false,
                ssUniqueTournamentId: null,
                mkCompetitionId: null
            }
        }
    },
    emits: ["loginResult", "pageLoaded"],
    beforeMount() {
        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });

        var page = {
            title: "SS-MK Tournament Links"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.getCategoryLinks()
    },
    methods: {
        async getCategoryLinks() {
            let categoryLinks = this.categoryLinks;

            categoryLinks.isLoading = true
            let response = await SpringApi.get('/api/links')
            categoryLinks.items = response.data
            categoryLinks.isLoading = false
        },
        previousCategory() {
            let currentSelected = this.categoryLinks.selected
            let currentCategoryId = currentSelected.ssCategoryContainer.id
            for(var i = 0; i < this.categoryLinks.items.length; i++) {
                if (this.categoryLinks.items[i].ssCategoryContainer.id === currentCategoryId 
                    && i > 0) {
                    this.categoryLinks.selected = this.categoryLinks.items[i - 1]
                }
            }
        },
        nextCategory() {
            let currentSelected = this.categoryLinks.selected
            let currentCategoryId = currentSelected.ssCategoryContainer.id
            for(var i = 0; i < this.categoryLinks.items.length; i++) {
                if (this.categoryLinks.items[i].ssCategoryContainer.id === currentCategoryId
                    && i + 1 < this.categoryLinks.items.length) {
                    this.categoryLinks.selected = this.categoryLinks.items[i + 1]
                }
            }
        },
        ssCategoryChanged() {
            // console.log('ssCategoryChanged: ', this.categoryLinks.selected)
        },
        mkCategoryChanged() {
            // console.log('mkCategoryChanged: ', this.categoryLinks.selected.mkAreaContainer)
        },
        async ssUniqueTournamentSelected() {
            try {
                this.tournamentLink.isLoading = true
                let uniqueTournamentLink = await SpringApi.get('/api/links/unique-tournaments/'+this.tournamentLink.ssUniqueTournamentId)
                this.tournamentLink.mkCompetitionId = uniqueTournamentLink.data.mkCompetitionId
            } catch(error) {
                this.tournamentLink.mkCompetitionId = null
            }
            this.tournamentLink.isLoading = false
        },
        async createTournamentLink() {
            let payload = {
                "ssCategoryId": this.categoryLinks.selected.ssCategoryContainer.id,
                "mkAreaId": this.categoryLinks.selected.mkAreaContainer.id,
                "mkCompetitionId": this.tournamentLink.mkCompetitionId
            }

            try {
                this.tournamentLink.isLoading = true
                let createTournamentLink = await SpringApi.post('/api/links/unique-tournaments/'+this.tournamentLink.ssUniqueTournamentId, payload)
                this.tournamentLink.ssUniqueTournamentId = createTournamentLink.data.ssUniqueTournamentId
                this.tournamentLink.mkCompetitionId = createTournamentLink.data.mkCompetitionId
            } catch(error) {
                console.log(error)
            }
            this.tournamentLink.isLoading = false
        },
        async removeTournamentLink() {
            this.$confirm.require({
                message: 'Remove tournament link?',
                header: 'Remove Link',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Remove',
                rejectLabel: 'Cancel',
                accept: async () => {
                    try {
                        this.tournamentLink.isLoading = true
                        await SpringApi.delete('/api/links/unique-tournaments/'+this.tournamentLink.ssUniqueTournamentId)
                        this.tournamentLink.mkCompetitionId = null
                    } catch(error) {
                        console.log(error)
                    }
                    this.tournamentLink.isLoading = false
                },
                reject: () => {
                }
            })
        }
    }
}
</script>
